import { stripUnit } from 'polished';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { Shimmer } from '../Shimmer/Shimmer';
import { BoxProps } from '../Box/Box';
import { theme as themeDefinition } from '../../../theme/theme';

export interface TextLoadingProps extends BoxProps {
  width: number | string;
  height?: keyof typeof themeDefinition.fontSizes;
}

export const TextLoading = styled(Shimmer)<TextLoadingProps>(
  ({ theme, width, height = 'body' }) => ({
    width,
    height: theme.fontSizes[height],
    marginTop: ((stripUnit(theme.lineHeights[height]) as number) - theme.fontSizes[height]) / 2,
    marginBottom: ((stripUnit(theme.lineHeights[height]) as number) - theme.fontSizes[height]) / 2,
  }),
  margin,
);
